import { render, staticRenderFns } from "./BonusItemExpandTable.vue?vue&type=template&id=f35b1e9e&scoped=true"
import script from "./BonusItemExpandTable.vue?vue&type=script&lang=js"
export * from "./BonusItemExpandTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35b1e9e",
  null
  
)

export default component.exports